import React from 'react'
import style from './style.module.scss'

const Footer = () => (
  <div className={style.footer}>
    <div className={style.footerInner}>
      <a
        href="https://sellpixels.com"
        target="_blank"
        rel="noopener noreferrer"
        className={style.logo}
      >
        MOBIDOC - Your personal assistant
        <span />
      </a>
      <br />
      <p className="mb-0">
        Copyright © 2017-2020 Mobidoc SA |{' '}
        <a href="https://app.mobidoc.com/privacy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </p>
    </div>
  </div>
)

export default Footer
